export interface UnmaskedPhoneNumber {
    id: string;
    phoneNumber: string;
}

export const emptyUnmaskedPhoneNumber: UnmaskedPhoneNumber = {
    id: '',
    phoneNumber: '',
};
